import React from "react";
import "./PmDashboard.css";
import {
  FolderKanban,
  Mail,
  Clock3,
  Activity,
  ArrowUpRight,
} from "lucide-react";

function PmDashboard() {
  return (
    <div className="pm-dashboard-page">
      {/* Header */}
      <div className="pm-dashboard-header">
        <div>
          <h1>PM Dashboard</h1>
          <p>
            Welcome back. Here’s a quick overview of your workspace.
          </p>
        </div>

        <button className="pm-dashboard-btn">
          View Reports
          <ArrowUpRight size={18} />
        </button>
      </div>

      {/* Stats */}
      <div className="pm-stats-grid">
        <div className="pm-stat-card">
          <div className="pm-stat-icon project-icon">
            <FolderKanban size={26} />
          </div>

          <div className="pm-stat-content">
            <h4>Total Projects</h4>
            <h2>124</h2>
            <span>+8 this month</span>
          </div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-icon pending-icon">
            <Clock3 size={26} />
          </div>

          <div className="pm-stat-content">
            <h4>Pending Tasks</h4>
            <h2>12</h2>
            <span>Needs attention</span>
          </div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-icon message-icon">
            <Mail size={26} />
          </div>

          <div className="pm-stat-content">
            <h4>Messages Sent</h4>
            <h2>1.2M</h2>
            <span>+12% growth</span>
          </div>
        </div>

        <div className="pm-stat-card">
          <div className="pm-stat-icon activity-icon">
            <Activity size={26} />
          </div>

          <div className="pm-stat-content">
            <h4>System Activity</h4>
            <h2>93%</h2>
            <span>Healthy performance</span>
          </div>
        </div>
      </div>

      {/* Recent Activity */}
      <div className="pm-table-card">
        <div className="pm-card-header">
          <h3>Recent Activity</h3>
          <button className="view-all-btn">View All</button>
        </div>

        <div className="activity-table-wrapper">
          <table className="activity-table">
            <thead>
              <tr>
                <th>Activity</th>
                <th>Project</th>
                <th>Status</th>
                <th>Time</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td>Email Campaign Created</td>
                <td>Marketing Portal</td>
                <td>
                  <span className="status completed">
                    Completed
                  </span>
                </td>
                <td>2 mins ago</td>
              </tr>

              <tr>
                <td>OTP Template Updated</td>
                <td>Authentication Service</td>
                <td>
                  <span className="status processing">
                    Processing
                  </span>
                </td>
                <td>15 mins ago</td>
              </tr>

              <tr>
                <td>New Config Added</td>
                <td>SMS Gateway</td>
                <td>
                  <span className="status completed">
                    Completed
                  </span>
                </td>
                <td>1 hour ago</td>
              </tr>

              <tr>
                <td>Failed Notification</td>
                <td>Billing Service</td>
                <td>
                  <span className="status failed">
                    Failed
                  </span>
                </td>
                <td>3 hours ago</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default PmDashboard;